/**
 * @generated SignedSource<<0c98c086c28d9d4b61c224661579e365>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HeaderWithComplexMenuMobile_authenticationConfig",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enableUserAccounts",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeaderAuthenticatedUser_authenticationConfig"
    }
  ],
  "type": "AuthenticationConfig",
  "abstractKey": null
};

node.hash = "5733740afd15fbfbd220586b87580269";

module.exports = node;
